module.exports = __webpack_public_path__ + "static/media/FLR_Wallpaper02_3840x2160.5271d255.jpg";